import React from 'react';
import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase';

//USER_DETAILS_LOADING-done
export const handleUserDetailsLoadingEvent = () => {
  logEvent(analytics, 'USER_DETAILS_LOADING');
};

//USER_DETAILS_LOADED-done
export const handleUserDetailsLoadedEvent = () => {
  logEvent(analytics, 'USER_DETAILS_LOADED');
};

//USER_DETAILS_FAILED-done
export const handleUserDetailsFailedEvent = () => {
  logEvent(analytics, 'USER_DETAILS_FAILED');
};

//MESSAGE_SELECTED-done
export const handleMessageSelectedEvent = () => {
  logEvent(analytics, 'MESSAGE_SELECTED');
};
//SEND_MESSAGE_CLICKED-done
export const handleSendMessageClickEvent = () => {
  logEvent(analytics, 'SEND_MESSAGE_CLICKED');
};

//SEND_MESSAGE_SUCCESS-done
export const handleMessageSendSuccessEvent = () => {
  logEvent(analytics, 'SEND_MESSAGE_SUCCESS');
};

//CALL_BUTTON_CLICKED-done
export const handleCallButtonClickedEvent = () => {
  logEvent(analytics, 'CALL_BUTTON_CLICKED');
};

//CALL_REJECTED
export const handleCallRejectedEvent = () => {
  logEvent(analytics, 'CALL_REJECTED');
};

//CALL_ACCEPTED-done
export const handleCallAcceptedEvent = () => {
  logEvent(analytics, 'CALL_ACCEPTED');
};

//CALL_CANCELLED-done
export const handleCallCancelledEvent = () => {
  logEvent(analytics, 'CALL_CANCELLED');
};

//THANKYOU_PAGE_SHOWN-done
export const handleThankyouPageShownEvent = () => {
  logEvent(analytics, 'THANKYOU_PAGE_SHOWN');
};

//CUSTOMER_PAGE_REDIRECTED-done
export const handleCustomerPageRedirectedEvent = () => {
  logEvent(analytics, 'CUSTOMER_PAGE_REDIRECTED');
};

//CALL_ENDED
export const handleCallEndedEvent = () => {
  logEvent(analytics, 'CALL_ENDED');
};

//CALL_ENDED_BY_USER
export const handleCallEndedByUserEvent = () => {
  logEvent(analytics, 'CALL_ENDED_BY_USER');
};
